import { useQueryClient } from '@tanstack/react-query';
import { getQueryBaseKey } from './getQueryKey';
export const getUseSetInfiniteQueryData = (wrapperOptions) => {
    const useSetInfiniteQueryData = () => {
        const queryClient = useQueryClient();
        const queryKey = getQueryBaseKey(wrapperOptions, 'infiniteQuery');
        const setQueryData = (updater) => {
            queryClient.setQueriesData({ queryKey, exact: false }, updater);
        };
        return setQueryData;
    };
    return useSetInfiniteQueryData;
};
